import { Dialog } from 'src/common/components/Dialog/Dialog';
import Portal from '@mui/material/Portal';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/common/components/Buttons/Button';
import { useState } from 'react';
import { AlertTitle } from 'src/common/Snackbar/AlertTitle';
import { AutoHideSnackbar } from 'src/common/Snackbar/AutoHideSnackbar';
import Typography from '@mui/material/Typography';

import { useESimProfileAdd } from './hooks/useESimAddProfile';
import { TextField } from 'src/common/components/Inputs/TextField/TextField';
import List from '@mui/material/List';
import { FilterListItem } from 'src/common/components/Filters/FilterListItem';
import { ESim } from '../../models/esim';

type ESimEnableDialogProps = {
  open: boolean;
  onClose: () => void;
  data: ESim;
};

export const ESimAddProfileDialog = ({ open, onClose, data }: ESimEnableDialogProps) => {
  const { t } = useTranslation();

  const [isSuccess, setIsSuccess] = useState(false);

  const [iccid, setIccid] = useState('');

  const { addESimProfile } = useESimProfileAdd({
    eid: data?.eid,
    iccid: iccid,
    mutationOption: {
      onSuccess: () => {
        onClose();
        setIsSuccess(true);
      },
    },
  });

  return (
    <>
      {data && (
        <Dialog
          open={open}
          title={t('products.eSim.inventory.actions.addESimProfile.title')}
          onClose={onClose}
          size="small"
          actions={
            <>
              <Button variant="secondary" onClick={onClose}>
                {t('common.cancel')}
              </Button>
              <Button
                variant="primary"
                onClick={() => {
                  addESimProfile();
                }}
              >
                {t('common.confirm')}
              </Button>
            </>
          }
        >
          <List>
            <FilterListItem label={t('common.iccid')} htmlFor="iccid">
              <TextField
                id="iccid"
                name="iccid"
                onChange={(e) => {
                  setIccid(e.target.value);
                }}
                value={iccid}
              />
            </FilterListItem>
          </List>
        </Dialog>
      )}
      <Portal>
        <AutoHideSnackbar
          severity="info"
          open={isSuccess}
          onClose={() => {
            setIsSuccess(false);
          }}
        >
          <AlertTitle>{t('products.eSim.inventory.actions.enable.success.title')}</AlertTitle>
          <Typography variant="text1" color="text.white">
            {t('products.eSim.inventory.actions.enable.success.description')}
          </Typography>
        </AutoHideSnackbar>
      </Portal>
    </>
  );
};
